// ============================================================
// TanStack React Query Client
// ============================================================

import { QueryClient } from '@tanstack/react-query';
import config from '@/config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: config.query.staleTime,
      gcTime: config.query.cacheTime,
      retry: config.query.retryCount,
      refetchOnWindowFocus: config.query.refetchOnWindowFocus,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
